/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CommoditiesControl } from "../controls/CommoditiesControl";

import { useSubscription } from "./useSubscription";

export default function () {
  useSubscription();
  return (
    <>
      <ReportToolbarGroup>
        <CommoditiesControl />
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </div>
    </>
  );
}
